export default __webpack_public_path__ + "static/ultherapy_3-6f1f25d13b23d6a3f21504ee49360d06.jpg";